import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "content", "icon"]

  toggle(event) {
    const button = event.currentTarget
    const index = button.dataset.index
    const content = this.contentTargets[index]
    const icon = this.iconTargets[index]
    const isOpen = content.classList.contains("hidden") === false

    if (isOpen) {
      content.classList.add("hidden")
      icon.classList.remove("rotate-180")
    } else {
      content.classList.remove("hidden")
      icon.classList.add("rotate-180")
    }
  }
}
